import { Koi } from '@ksyos/koi';

export interface IAddCarePathServiceReaderSettingsValidated {
    id: string;
    isDisabled: boolean;
}

export const serviceReaderSettingsAdd = Koi.object().keys({
    id: Koi.string().uuid(),
    isDisabled: Koi.boolean(),
});
